import { render, staticRenderFns } from "./ProductProfit.vue?vue&type=template&id=10a66285&"
import script from "./ProductProfit.vue?vue&type=script&lang=js&"
export * from "./ProductProfit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../frontend-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports